// Lead Management Help Content (HTML)
export const leadHelpContent = `
<h1>คู่มือการจัดการ Leads (Lead Management)</h1>

<h2>ภาพรวม</h2>
<p>ระบบจัดการ Leads ช่วยให้คุณสามารถสร้าง ติดตาม และแปลง Leads เป็น Opportunities เพื่อปิดการขายได้อย่างมีประสิทธิภาพ</p>

<h2>Lead คืออะไร?</h2>
<p><strong>Lead</strong> คือบุคคลหรือบริษัทที่มีความสนใจในผลิตภัณฑ์หรือบริการของคุณ แต่ยังไม่ได้อยู่ในขั้นตอนการขายอย่างเป็นทางการ</p>

<h2>วงจรชีวิตของ Lead (Lead Lifecycle)</h2>
<ol>
  <li><strong>New</strong> - Lead ใหม่ที่เพิ่งเข้ามาในระบบ</li>
  <li><strong>Contacted</strong> - ได้ติดต่อ Lead แล้ว</li>
  <li><strong>Qualified</strong> - Lead ที่ผ่านการคัดกรองแล้ว มีความสนใจจริง</li>
  <li><strong>Converted</strong> - แปลงเป็น Opportunity แล้ว</li>
  <li><strong>Lost</strong> - Lead ที่ไม่สามารถปิดการขายได้</li>
</ol>

<h2>ฟิลด์สำคัญ</h2>

<h3>ฟิลด์พื้นฐาน</h3>
<table>
  <thead>
    <tr>
      <th>ฟิลด์</th>
      <th>คำอธิบาย</th>
      <th>จำเป็น</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td><strong>Lead Name / Title</strong></td>
      <td>ชื่อหรือหัวข้อของ Lead</td>
      <td>✅</td>
    </tr>
    <tr>
      <td><strong>Contact Name</strong></td>
      <td>ชื่อผู้ติดต่อ</td>
      <td>❌</td>
    </tr>
    <tr>
      <td><strong>Company Name</strong></td>
      <td>ชื่อบริษัท (ถ้ามี)</td>
      <td>❌</td>
    </tr>
    <tr>
      <td><strong>Email</strong></td>
      <td>อีเมลติดต่อ</td>
      <td>❌</td>
    </tr>
    <tr>
      <td><strong>Phone</strong></td>
      <td>เบอร์โทรศัพท์</td>
      <td>❌</td>
    </tr>
    <tr>
      <td><strong>Status</strong></td>
      <td>สถานะของ Lead (New, Contacted, Qualified, etc.)</td>
      <td>✅</td>
    </tr>
    <tr>
      <td><strong>Source</strong></td>
      <td>แหล่งที่มาของ Lead (Website, Referral, Trade Show, etc.)</td>
      <td>❌</td>
    </tr>
    <tr>
      <td><strong>Priority</strong></td>
      <td>ลำดับความสำคัญ (High, Medium, Low)</td>
      <td>❌</td>
    </tr>
  </tbody>
</table>

<h3>ฟิลด์เพิ่มเติม</h3>
<ul>
  <li><strong>Lead Score</strong>: คะแนนที่ใช้ประเมินความน่าจะเป็นในการปิดการขาย</li>
  <li><strong>Budget</strong>: งบประมาณที่ Lead มี</li>
  <li><strong>Expected Close Date</strong>: วันที่คาดว่าจะปิดการขาย</li>
  <li><strong>Description</strong>: คำอธิบายเพิ่มเติม</li>
  <li><strong>Salesperson</strong>: พนักงานขายที่ดูแล Lead</li>
</ul>

<h2>การแปลง Lead เป็น Opportunity</h2>
<p>เมื่อ Lead พร้อมที่จะเข้าสู่กระบวนการขายแล้ว คุณสามารถแปลง Lead เป็น Opportunity ได้:</p>
<ol>
  <li>เปิดหน้า Lead Detail</li>
  <li>คลิกปุ่ม "Convert to Opportunity"</li>
  <li>ระบบจะสร้าง Opportunity ใหม่และเชื่อมโยงกับ Lead</li>
  <li>สถานะของ Lead จะเปลี่ยนเป็น "Converted"</li>
</ol>

<h2>Lead Scoring</h2>
<p>Lead Score คือคะแนนที่ใช้ประเมินความน่าจะเป็นในการปิดการขาย โดยพิจารณาจาก:</p>
<ul>
  <li>ข้อมูลที่กรอกครบถ้วน</li>
  <li>แหล่งที่มา (Source) ของ Lead</li>
  <li>พฤติกรรมการใช้งาน</li>
  <li>ความสนใจในผลิตภัณฑ์</li>
</ul>
<p>Lead Score สูง = โอกาสในการปิดการขายสูง</p>

<h2>Lead Enrichment</h2>
<p>ระบบสามารถเสริมข้อมูล Lead อัตโนมัติด้วย AI และการค้นหาข้อมูล:</p>
<ul>
  <li>ค้นหาข้อมูลบริษัทจากแหล่งข้อมูลต่างๆ</li>
  <li>เสริมข้อมูลติดต่อ</li>
  <li>เพิ่มข้อมูลอุตสาหกรรมและขนาดบริษัท</li>
</ul>

<h2>การเชื่อมโยงข้อมูล</h2>
<p>Lead สามารถเชื่อมโยงกับ:</p>
<ul>
  <li><strong>Customer</strong>: เมื่อแปลงเป็น Opportunity และปิดการขายแล้ว</li>
  <li><strong>Opportunity</strong>: โอกาสการขายที่เกิดขึ้นจาก Lead</li>
  <li><strong>Activities</strong>: กิจกรรมที่เกี่ยวข้องกับ Lead</li>
  <li><strong>Notes</strong>: หมายเหตุ</li>
  <li><strong>Attachments</strong>: ไฟล์แนบ</li>
</ul>

<h2>คำแนะนำการใช้งาน</h2>

<h3>การสร้าง Lead ใหม่</h3>
<ol>
  <li>กรอกชื่อหรือหัวข้อของ Lead (จำเป็น)</li>
  <li>เพิ่มข้อมูลติดต่อ (Email, Phone) หากมี</li>
  <li>ระบุ Source เพื่อติดตามแหล่งที่มา</li>
  <li>เลือก Status และ Priority</li>
  <li>คลิก "Save" เพื่อบันทึก</li>
</ol>

<h3>การจัดการ Lead</h3>
<ul>
  <li>อัปเดต Status เป็นประจำเพื่อติดตามความคืบหน้า</li>
  <li>เพิ่ม Activities เพื่อบันทึกการติดต่อ</li>
  <li>เพิ่ม Notes เพื่อบันทึกข้อมูลสำคัญ</li>
  <li>ใช้ Lead Score เพื่อจัดลำดับความสำคัญ</li>
</ol>

<h3>การค้นหาและกรอง</h3>
<ul>
  <li>ใช้ช่องค้นหาเพื่อหา Lead จากชื่อ อีเมล หรือบริษัท</li>
  <li>กรองตาม Status, Source, Priority</li>
  <li>จัดเรียงตาม Lead Score เพื่อหาว่าควรติดต่อใครก่อน</li>
</ul>

<h2>การแก้ไขปัญหา</h2>

<h3>ไม่สามารถแปลง Lead เป็น Opportunity ได้</h3>
<ul>
  <li>ตรวจสอบว่ากรอกข้อมูลจำเป็นครบถ้วน</li>
  <li>ตรวจสอบสิทธิ์การเข้าถึง</li>
  <li>ดูข้อความ error ที่แสดง</li>
</ul>

<h3>Lead Score ไม่แสดง</h3>
<ul>
  <li>ตรวจสอบว่ามีข้อมูลเพียงพอสำหรับการคำนวณคะแนน</li>
  <li>ระบบจะคำนวณคะแนนอัตโนมัติเมื่อมีข้อมูลครบ</li>
</ul>

<h2>เคล็ดลับ</h2>
<ul>
  <li>✅ ระบุ Source ให้ชัดเจนเพื่อติดตาม ROI ของแต่ละช่องทาง</li>
  <li>✅ อัปเดต Status เป็นประจำเพื่อให้เห็นความคืบหน้าชัดเจน</li>
  <li>✅ ใช้ Lead Score เพื่อจัดลำดับการติดต่อ</li>
  <li>✅ เพิ่ม Activities เพื่อบันทึกประวัติการติดต่อ</li>
  <li>✅ แปลง Lead เป็น Opportunity ทันทีที่พร้อม</li>
  <li>✅ ใช้ Tags เพื่อจัดกลุ่ม Lead ตามประเภท</li>
</ul>

<p><em><strong>อัปเดตล่าสุด</strong>: ธันวาคม 2025</em></p>
`;

